import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "103",
  height: "96",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"102\" height=\"95\" x=\".5\" y=\".5\" fill=\"#fff\" rx=\"7.5\"></rect><rect width=\"102\" height=\"95\" x=\".5\" y=\".5\" stroke=\"#EAECF0\" rx=\"7.5\"></rect><path fill=\"#D0D5DD\" d=\"M4 10a6 6 0 0 1 6-6h83a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6V10Z\"></path><rect width=\"39\" height=\"8\" x=\"12\" y=\"61\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"23\" height=\"8\" x=\"12\" y=\"76\" fill=\"#EAECF0\" rx=\"4\"></rect>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }